<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:30:26
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" :sm="disabled ? 6 : 12">
            <mrc_ess_multiText
              :label="$t('label_SwiftName') + '*'"
              :error-messages="
                $errors('list', 'swift_config_name', requiredRule)
              "
              :isNational="judegNational('swift_config_name')"
              v-model="list.swift_config_name"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6" v-if="disabled">
            <mrc_ess_multiText
              :label="$t('label_Preview')"
              :isNational="judegNational('swift_config_preview')"
              v-model="list.swift_config_preview"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" class="mb-5">
            <div
              style="font-size: 20px; color: rgba(0, 0, 0, 0.38)"
              class="text-h5"
            >
              {{ $t("label_Prefix") }}
            </div>
          </v-col>
          <v-col cols="12">
            <v-card flat outlined rounded="lg">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <!--     :error-messages="$errors('list','swift_config_prefix_first',requiredRule)" -->
                    <mrc_ess_multiText
                      :label="$t('label_FirstValue') + '*'"
                      :isNational="judegNational('swift_config_prefix_first')"
                      v-model="list.swift_config_prefix_first"
                      :error-messages="
                        $errors(
                          'list',
                          'swift_config_prefix_first',
                          requiredRule
                        )
                      "
                      :readonly="disabled"
                    >
                    </mrc_ess_multiText>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!--                                  :error-messages="$errors('list','swift_config_prefix_object',requiredRule)" -->
                    <mrc_ess_multiText
                      :label="$t('label_Object')"
                      noRequired
                      :isNational="judegNational('swift_config_prefix_object')"
                      v-model="list.swift_config_prefix_object"
                      :readonly="disabled"
                    >
                    </mrc_ess_multiText>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!--                                  :error-messages="$errors('list','swift_config_prefix_second',requiredRule)" -->
                    <mrc_ess_multiText
                      :label="$t('label_SecondValue')"
                      noRequired
                      :isNational="judegNational('swift_config_prefix_second')"
                      v-model="list.swift_config_prefix_second"
                      :readonly="disabled"
                    >
                    </mrc_ess_multiText>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" class="mt-7 mb-7">
            <mrc_ess_NumInput
              :readonly="disabled"
              :error-messages="
                $errors(
                  'list',
                  'swift_config_length',
                  between('000-999').concat(requiredRule)
                )
              "
              :label="$t('label_Length') + '*'"
              v-model="list.swift_config_length"
            ></mrc_ess_NumInput>
          </v-col>
          <v-col cols="12" sm="6" class="mt-7 mb-7">
            <mrc_ess_NumInput
              :readonly="disabled"
              :error-messages="
                $errors(
                  'list',
                  'swift_config_start_index',
                  between('000-999').concat(requiredRule)
                )
              "
              :label="$t('label_StartIndex') + '*'"
              v-model="list.swift_config_start_index"
            ></mrc_ess_NumInput>
          </v-col>
          <v-col cols="12" class="mb-5">
            <div
              class="text-h5"
              style="font-size: 20px; color: rgba(0, 0, 0, 0.38)"
            >
              {{ $t("label_Postfix") }}
            </div>
          </v-col>
          <v-col cols="12" class="mb-2">
            <v-card flat outlined rounded="lg">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <!-- :error-messages="$errors('list','swift_config_suffix_first',requiredRule)" -->
                    <mrc_ess_multiText
                      :label="$t('label_suffix_fixed_value')"
                      noRequired
                      :isNational="judegNational('swift_config_suffix_first	')"
                      v-model="list.swift_config_suffix_first"
                      :readonly="disabled"
                    >
                    </mrc_ess_multiText>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!-- :error-messages="$errors('list','swift_config_suffix_object',requiredRule)" -->
                    <mrc_ess_multiText
                      :label="$t('label_suffix_object')"
                      noRequired
                      :isNational="judegNational('swift_config_suffix_object')"
                      v-model="list.swift_config_suffix_object"
                      :readonly="disabled"
                    >
                    </mrc_ess_multiText>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!--     :error-messages="$errors('list','swift_config_suffix_second',requiredRule)" -->
                    <mrc_ess_multiText
                      :label="$t('label_suffix_fixed_value_two')"
                      noRequired
                      :isNational="judegNational('swift_config_suffix_second')"
                      v-model="list.swift_config_suffix_second"
                      :readonly="disabled"
                    >
                    </mrc_ess_multiText>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_prompt
              :label="$t('label_Table') + '*'"
              :errMsg="$errors('list', 'swift_config_table', requiredRule)"
              :rules="false"
              :disabled="disabled"
              v-model="list.swift_config_table"
              obj="table_name"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_prompt
              :label="$t('label_Field') + '*'"
              :errMsg="$errors('list', 'swift_config_field', requiredRule)"
              :rules="false"
              :disabled="disabled"
              v-model="list.swift_config_field"
              :obj="relation_field"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12">
            <!-- :backgroundColor="disabled?'#ffffff':'#f5f5f5'" -->
            <!-- :errMsg="$errors('list','org_level_uuid',requiredRule)" -->
            <!-- obj="org_level_for_clients" -->

            <!-- <mrc_ess_prompt :disabled="disabled"
                            obj='client-levels'
                            value_field="uuid"
                            :label="$t('label_company')"
                            v-model="list.org_level_uuid"></mrc_ess_prompt> -->

            <mrc_ess_autoComplete
              :label="$t('label_company') + '*'"
              orgView
              :errorMessages="$errors('list', 'org_level_uuid', requiredRule)"
              :readonly="disabled"
              v-model="list.org_level_uuid"
              :prompt_name="unitObj"
            >
            </mrc_ess_autoComplete>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getserialNumberList,
  createSerialNumber,
  detailSerialNumber,
  addSerialNumber,
  updateSerialNumber,
  deleteSerialNumber,
} from "@/service/api/serialNumber.js";
import { getBusinessList } from "@/service/api/prompt.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
import Mrc_ess_autoComplete from "../../components/mrc_ess_autoComplete.vue";
export default {
  components: { Mrc_ess_autoComplete },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      snackbar: false,
      skeletonloading: true,
      list: {
        swift_config_length: 1,
        swift_config_start_index: 1,
        swift_config_prefix_object: "",
        swift_config_prefix_second: "",
        swift_config_suffix_first: "",
        swift_config_suffix_object: "",
        swift_config_suffix_second: "",
      },
      btnIsLoading: false,
    };
  },
  computed: {
    unitObj() {
      let obj = {};
      switch (this.$store.state.userData.userType) {
        case 1:
          obj = { prompt_name: "org_level_for_clients" };
          break;
        case 2:
          obj = {
            prompt_name: "org_levels_manager_filter_company_company",
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
          };
          break;
        case 3:
          obj = {
            prompt_name: "org_levels_manager_filter_company_company",
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
          };
          break;
        default:
          obj = {
            prompt_name: "org_levels_manager_filter_company_other",
            user_id: this.$store.state.userData.user_id,
            client_uuid: this.$store.state.userData.clientUuid,
          };
      }
      return obj;
    },
    relation_field() {
      return {
        prompt_name: "serial_number",
        source_table: this.list.swift_config_table,
      };
    },
  },
  created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_swift_config");
    if (this.$store.state.uuid) {
      await this.getDetail();
    } else {
    }
  },

  methods: {
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailSerialNumber({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.btnIsLoading = true;
      if (this.$store.state.uuid) {
        updateSerialNumber(this.$deletefield(null, this.list)).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getDetail();
            this.$emit("changeReadonly");
          }
          this.btnIsLoading = false;
        });
      } else {
        addSerialNumber(this.$deletefield(null, this.list)).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "serial-number" });
          }
          this.btnIsLoading = false;
        });
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "serial-number",
            });
          })
          .catch((err) => {});
      }
    },
  },
  validations: {
    list: {
      swift_config_name: {
        required,
      },

      swift_config_prefix_first: {
        required,
      },
      // swift_config_prefix_object: {

      // },
      // swift_config_prefix_second: {

      // },
      swift_config_length: {
        required,
        between: between(0, 999),
      },
      swift_config_start_index: {
        required,
        between: between(0, 999),
      },
      // swift_config_suffix_first: {
      //
      // },
      // swift_config_suffix_object: {

      // },
      // swift_config_suffix_second: {

      // },
      swift_config_table: {
        required,
      },
      swift_config_field: {
        required,
      },
      org_level_uuid: {
        required,
      },
    },
  },
};
</script>

<style scoped></style>
